// extracted by mini-css-extract-plugin
export default {"operationArea":"Employee_operationArea__ITo-W","footerSty":"Employee_footerSty__cCG5p"};